/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：425
 */

var r = require(/* 271 */"../1648/271")
var o = require(/* 300 */"../1648/300/index")
var i = require(/* 631 */"../1282/631")
module.exports = r ? function (e, t, n) {
  return o.f(e, t, i(1, n))
} : function (e, t, n) {
  e[t] = n
  return e
}
